export const OFFERS_BY_ALIAS_ROUTE = '/offers/';
export const PROGRAMS_BY_ALIAS_ROUTE = '/programs/';
export const OFFERS_ARCHIVE_ROUTE = '/offers/archive';
export const PROGRAMS_ARCHIVE_ROUTE = '/programs/archive';
